import React from "react";
import { Link } from "react-router-dom";
import { Github } from "lucide-react";
import { logEvent } from "@/lib/analytics";

const WHATSAPP_NUMBER = "919028230554";
const GITHUB_LINK = "https://github.com/stylish00killer";

const createWhatsAppLink = (pack) => {
  const message = encodeURIComponent(`I want to buy the Alice Bot ${pack} Pack`);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
};

const Footer = () => (
  <footer className="py-12 border-t border-white/10" data-testid="footer-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-center md:text-left">
          <h3 className="font-outfit text-2xl font-bold text-gradient mb-2">Alice Bot</h3>
          <p className="text-gray-500 text-sm">Ultimate WhatsApp Group Automation</p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-gray-400">
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="hover:text-emerald-main transition-colors duration-300">Home</button>
          <a href="#features" className="hover:text-emerald-main transition-colors duration-300">Features</a>
          <a href="#pricing" className="hover:text-emerald-main transition-colors duration-300">Pricing</a>
          <a href="#how-it-works" className="hover:text-emerald-main transition-colors duration-300">How It Works</a>
          <a
            href={GITHUB_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-emerald-main transition-colors duration-300 flex items-center gap-2"
            data-testid="footer-github-link"
            onClick={() => logEvent('Engagement', 'Click', 'GitHub Footer')}
          >
            <Github className="w-4 h-4" />
            GitHub
          </a>
          <a
            href={createWhatsAppLink("General")}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-emerald-main transition-colors duration-300"
            data-testid="footer-contact-link"
            onClick={() => logEvent('Contact', 'Click', 'WhatsApp Footer')}
          >
            Contact
          </a>
          <Link to="/privacy" className="hover:text-emerald-main transition-colors duration-300 cursor-pointer">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-emerald-main transition-colors duration-300 cursor-pointer">Terms of Service</Link>
        </div>
      </div>

      <div className="mt-8 pt-8 border-t border-white/10 text-center">
        <p className="text-gray-600 text-sm">
          Bot sold as service. WhatsApp is a trademark of Meta Platforms, Inc. Not affiliated.
        </p>
        <p className="text-gray-600 text-sm mt-2">
          © {new Date().getFullYear()} Alice Bot. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
